import actionTypes from './index';

export default itemId => ({ type: actionTypes.TOGGLE_EXPAND_ITEM, payload: { itemId } });
